<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exp"
				ref="SetBtn"
        ></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column show-overflow-tooltip prop="hostname" :label="$t('getapi[344]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="IP" :label="$t('getapi[345]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="employeeName" :label="$t('getapi[346]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="operation" :label="$t('getapi[347]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="objecttype" :label="$t('getapi[348]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="operationValue" :label="$t('getapi[349]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="newValue" :label="$t('getapi[350]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="oldValue" :label="$t('getapi[351]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[1288]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="c3" :label="$t('getapi[1289]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="c4" :label="$t('getapi[1290]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="actionDateTime" :label="$t('getapi[352]')">
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="SchQuotationTraceViewInfo" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
		name:'schqtchangehistory',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                user: "", // 当前用户
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('schqtchangehistory'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                showloading: '',
                queryData: [],
                scrollTop:0,
            };
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
			that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[87]"),this.$t("getapi[17]"));
            },
			authority() {
				let that = this;
					//只读权
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.total > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
					
			},
            //修改页数
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('schqtchangehistory',val)
                this.intidata();
				this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
				this.authority();
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SchQuotationTraceViewInfo');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign,
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Sch/QtChange/SchQuotationTraceView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
						that.total = res.Totals;
						that.DbTbNames = res.DbTbNames;
                        that.loading = false;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndexs)
                    });
					that.authority();
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: [],
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[87]')
                };
                that.queryData.forEach(item => {
                    if(item.query_Condition==''||item.query_Condition.length>0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                that.$http.urlpost('/Sch/QtChange/SchQTrace_ExportToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
